import { TokenTimeRange } from '@/request/token/token.request.interface';

export const TOKEN_TIME_TAB_CONFIG = [
  {
    label: TokenTimeRange['1m'],
    value: TokenTimeRange['1m'],
  },
  {
    label: TokenTimeRange['5m'],
    value: TokenTimeRange['5m'],
  },
  {
    label: TokenTimeRange['1h'],
    value: TokenTimeRange['1h'],
  },
  {
    label: TokenTimeRange['6h'],
    value: TokenTimeRange['6h'],
  },
  {
    label: TokenTimeRange['24h'],
    value: TokenTimeRange['24h'],
  },
];
